import React, { useState, useMemo } from "react";
import {
  Box,
  Grid,
  Card,
  Typography,
  TextField,
  InputAdornment,
  LinearProgress,
} from "@mui/material";
import { regexConstants } from "../../../constants/regEx";

const LGGroupingAllocation = ({modeType,reserveRates,onMultiFieldChange})=> {
  const total = useMemo(() => {
    return reserveRates?.lg_allocations?.reduce((sum, item) => sum + Number(item.percentage || 0), 0);
  }, [reserveRates?.lg_allocations]);

  const isValid = total === 100;
  return (
    <>
      <Box className="escalation-container">
        <Box className="lg-grouping-container">
          <Typography sx={{ mt: 0.5,mb:0.7, fontSize: "15px" }}>
            Define the percentage of the grouped LG invoice amount to be distributed
            to each Landing Gear. Total must equal 100%.
          </Typography>
          <Grid container spacing={1}>
            {reserveRates?.lg_allocations?.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
                <Card
                  sx={{
                    p: 1,
                    borderRadius: "6px",
                    boxShadow: "none",
                    border: "1px solid #d7e4f3",
                  }}
                >
                  <Box display="flex" alignItems="center" gap={1} >
                    <Typography fontWeight={700} fontSize={14}>
                       {item.name}
                    </Typography>
                  </Box>
                  <TextField
                    required
                    id="reserve_rate_per_interval"
                    value={item?.percentage}
                      onChange={(e) => { regexConstants.decimalnodotstart.test(e.target.value) ? onMultiFieldChange("lg_allocations", index, 'percentage', e.target.value,) : e.preventDefault() }}
                    variant="outlined"
                    size="small"
                    margin="normal"
                    // error={!!error.reserve_rate_per_interval}
                    // helperText={error.reserve_rate_per_interval}
                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 11 }, input: {endAdornment: (<InputAdornment position="end">%</InputAdornment>) }}}
                    fullWidth
                    sx={{ mb: 1,}}
                    disabled={modeType === 'view'}
                  />
                  
                  <LinearProgress
                    variant="determinate"
                    value={Math.min(Number(item?.percentage || 0), 100)}
                    sx={{
                      height: 8,
                      borderRadius: 10,
                      backgroundColor: "#d7dee8",
                      "& .MuiLinearProgress-bar": {
                        borderRadius: 10,
                        backgroundColor: "#2f6fb2",
                      },
                    }}
                  />
                </Card>
              </Grid>
            ))}
          </Grid>
          {modeType !== "view" &&   <Box
            mt={1}
            p={0.8}
            borderRadius="6px"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              backgroundColor: isValid ? "#dff4e5" : "#ffe3e3",
              border: `1px solid ${isValid ? "#9dd9ac" : "#ff8c8c"}`,
            }}
          >
            <Typography
              fontWeight={700}
              fontSize={13}
              color={isValid ? "#177a35" : "#c62828"}
            >
              Total Allocation
            </Typography>

            <Typography
              fontWeight={800}
              fontSize={13}
              color={isValid ? "#177a35" : "#c62828"}
            >
              {total?.toFixed(2)}% {isValid ? "✓ Valid" : "✕ Must equal 100%"}
            </Typography>
          </Box>}
        
        </Box>
      </Box>

    </>


  );
}

export default LGGroupingAllocation